<script setup>
import gsap from 'gsap'
import { ref, computed } from 'vue'
import { useServiceStore } from '@stores/service.js'
import Button from '@components/global/forms/Button.vue'
import ProjectCard from '@components/index/ProjectCard.vue'
import TransitionFade from '@components/global/transitions/TransitionFade.vue'

const serviceStore = useServiceStore()
const filter = ref(null)

const filteredProjects = computed(() => {
	return filter.value == null ? serviceStore.featuredProjects : serviceStore.categories[filter.value].showcased_projects
})
</script>

<template>
	<section class="overflow-hidden py-10 lg:py-16" v-if="serviceStore.featuredProjects?.length">
		<div class="container">
			<div class="flex flex-col justify-between gap-5 xl:flex-row xl:items-center">
				<h4>Featured Projects</h4>
				<div class="flex flex-wrap gap-1">
					<Button :class="{ active: filter == null }" variant="metro" @click="filter = null">All</Button>
					<Button :class="{ active: filter == i }" variant="metro" v-for="(category, i) in serviceStore.filterCategories" @click="filter = i">{{ category.name }}</Button>
				</div>
			</div>
			<!-- <TransitionFade> -->
			<div class="py-10">
				<ProjectCard v-for="(project, i) in filteredProjects" :project="project" :i="i + 1" :key="i" />
			</div>
			<!-- </TransitionFade> -->

			<Button mega="swords" label="All Work" :to="{ name: 'work' }">All Work</Button>
		</div>
	</section>
</template>

<style scoped>
.project-leave-active {
	@apply absolute;
}
</style>
